import moment from "moment";
import CostCenter from "./CostCenter";
import TransportationPermissionExtra from "../models/TransportationPermissionExtra";

export enum TransportationPermissionSourceEnum {
  Movit,
  Timit,
  Likuma
}

export enum DeductiblePaymentEnum {
  Car = 0,
  Invoice = 1
}

export enum DeductibleTypeEnum {
  NoDeductible = 0,
  Static = 1,
  Matkahuolto = 100,
  WalttiHäme = 101,
  Riihimäki = 102,
  Nysse = 103,
  EuraMatkahuolto = 104,
  KessoteMatkahuolto = 105,
  RaumaMatkahuolto = 106,
  PoriMatkahuolto = 107,
  HslTwoZoneMonthly = 108,
  AskolaAsiointi = 109,
  AskolaTyo = 110,
  AskolaOpiskelu = 111,
  Loviisa = 112,
  PorvooAsiointi = 113,
  PorvooTyo = 114,
  PorvooOpiskelu = 115,
  PorvooSHL = 116,
  SipooAsiointi = 117,
  SipooTyo = 118,
  SipooSHL = 119,
  HslStudentMonthly = 120,
  SipooOpiskelu = 121,
  WalttiJKL = 122,
  Vpl = 123,
  FixedMonthly = 124,
  KeusoteMatkahuolto = 125,
}

export default class TransportationPermission {
  id: number | null;
  externalId: string;
  // NOTE: Passenger's MovitId
  source: number;
  name: string | null;
  isDraft: boolean;
  tripType: string;
  decisionType: string;
  costCenter: CostCenter;
  child: boolean;
  passengerId: number;
  tripDestinations: number;
  deductiblePayment: DeductiblePaymentEnum;
  deductibleType: DeductibleTypeEnum;
  fixedDeductible: number | null;
  distanceLimit: number | null;
  initialQuota: number;
  initialExpressQuota: number;
  remainingQuota: number | null;
  quotaTime: number;
  startDate: string;
  endDate: string;
  note: string | null;
  accountKey: string | null;
  priceCode: string | null;
  extras?: TransportationPermissionExtra[];
  tripDirection: number;

  // NOTE: Timit only
  timitPassengerId: number;
  movitInstanceId: number | null;

  constructor(options) {
    this.id = options && options.id ? options.id : null;
    this.externalId = options && options.externalId ? options.externalId : "";
    this.source = options && options.source ? options.source : 0;
    this.passengerId = options && options.passengerId ? options.passengerId : 0;
    this.name = options && options.name ? options.name : null;
    this.isDraft = options && typeof options.isDraft === "boolean" ? options.isDraft : true;

    this.tripType = options && options.tripType ? options.tripType : "";
    this.decisionType = options && options.decisionType ? options.decisionType : "";
    this.costCenter = options && options.costCenter ? new CostCenter(options.costCenter) : new CostCenter({});
    this.child = options && options.child ? true : false;
    this.distanceLimit = options && options.distanceLimit ? options.distanceLimit : null;

    this.deductiblePayment = options && options.deductiblePayment ? options.deductiblePayment : 0;

    this.deductibleType = options && options.deductibleType ? options.deductibleType : 0;
    this.fixedDeductible = options && options.fixedDeductible ? options.fixedDeductible : null;
    this.initialQuota = options && options.initialQuota ? options.initialQuota : 0;
    this.initialExpressQuota = options && options.initialExpressQuota ? options.initialExpressQuota : 0;
    this.remainingQuota = options && options.remainingQuota ? options.remainingQuota : null;
    this.startDate = options && options.startDate ? options.startDate : null;
    this.endDate = options && options.endDate ? options.endDate : null;
    this.note = options && options.note ? options.note : null;

    this.timitPassengerId = options && options.timitPassengerId ? options.timitPassengerId : null;
    this.movitInstanceId = options && options.movitInstanceId ? options.movitInstanceId : null;
    this.quotaTime = options && options.quotaTime ? options.quotaTime : 0;
    this.accountKey = options && options.accountKey ? options.accountKey : null;
    this.priceCode = options && options.priceCode ? options.priceCode : null;
    this.tripDestinations = options && options.tripDestinations ? options.tripDestinations : 0;
    this.extras = options && options.extras ? options.extras : [];
    this.tripDirection = options && options.tripDirection ? options.tripDirection : 0;
  }

  static CopyFrom(
    transportationPermission: TransportationPermission
  ): TransportationPermission {
    return new TransportationPermission(transportationPermission);
  }

  get startDateYMD() {
    return moment(this.startDate).format("YYYY-MM-DD");
  }

  set startDateYMD(val) {
    this.startDate = moment(val)
      .startOf("day")
      .format("YYYY-MM-DD");
  }

  get startDateFormatted() {
    return moment(this.startDate).format("YYYY-MM-DD");
  }

  get endDateYMD() {
    return moment(this.endDate).format("YYYY-MM-DD");
  }

  set endDateYMD(val) {
    this.endDate = moment(val)
      .endOf("day")
      .format("YYYY-MM-DD");
  }

  get endDateFormatted() {
    return moment(this.endDate).format("YYYY-MM-DD");
  }

  get remainingQuotaFormatted() {
    return this.remainingQuota === null
      ? this.initialQuota
      : this.remainingQuota;
  }
}
